<template>
  <div class="content-block lease-banner">
    <v-row row>
      <v-col
        sm="7"
        cols="12"
        class="lease-banner__text d-flex justify-center flex-column"
      >
        <div class="subtitle">
          Exceptional customer service
        </div>
        <h3>About {{ title }}</h3>
        <p v-html="text" />
      </v-col>
      <v-col
        sm="5"
        cols="12"
        class="lease-banner__icon"
      >
        <img
          :src="require('@/assets/svg/leaseBanner.svg')"
          alt=""
        >
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'

  @Component({})
export default class OrganizationAbout extends Vue {
    @Prop({ type: String }) title!: string
    @Prop({ type: String }) text!: string
}
</script>

<style lang="scss">
  .lease-banner {
    padding: 0;
    &__text {
      padding: 3.125rem 7.4% 0.75rem 0.75rem;
      .subtitle {
        margin-bottom: 0.25rem;
      }
      h3 {
        line-height: 1.5;
        margin-bottom: 1rem;
      }
      p {
        font-size: 1.125rem;
        color: var(--v-textSecondary-base)
      }
    }
    &__icon {
      display: flex;

      img {
        display: block;
        max-width: 100%;
      }
    }
  }
</style>
